import { useEffect, useState } from 'react'
import './index.css'
import { FallingStars } from './FallingStars'
import { readBotLinkFromPage, type BotLinkState } from './botState'
import { LOCALE_STORAGE_KEY, readStoredLocale, t, type Locale } from './i18n'

export function App() {
	const [locale, setLocale] = useState<Locale>(readStoredLocale)
	const [botLink] = useState<BotLinkState>(readBotLinkFromPage)
	const copy = t(locale)

	useEffect(() => {
		try {
			localStorage.setItem(LOCALE_STORAGE_KEY, locale)
		} catch (error) {
			console.error('Failed to save locale to localStorage:', error)
		}
	}, [locale])

	return (
		<div className='landing'>
			<FallingStars />
			<main className='landing__main'>
				<h1 className='landing__title landing__title--main'>Prime Shop</h1>
				<div className='landing__container'>
					<div className='landing__panel landing__panel--info'>
						<h2 className='landing__title landing__title--small'>
							{copy.siteTitle}
						</h2>
						<p className='landing__desc'>{copy.siteDesc}</p>
						<div className='landing__cta'>
							<a
								className='landing__button'
								lang={locale}
								href='https://bot.primestore.st'
							>
								{copy.siteBtn}
							</a>
						</div>
					</div>
					<div className='landing__panel landing__panel--info'>
						<h2 className='landing__title landing__title--small'>
							{copy.botTitle}
						</h2>
						<p className='landing__desc'>{copy.botDesc}</p>
						<div className='landing__cta'>
							{botLink.ok ? (
								<a
									className='landing__button'
									lang={locale}
									href={botLink.url}
									target='_blank'
									rel='noopener noreferrer'
								>
									{copy.botBtn}
								</a>
							) : (
								<button
									type='button'
									className='landing__button landing__button--disabled'
									disabled
									lang={locale}
									aria-disabled='true'
								>
									{copy.botBtn}
								</button>
							)}
							{!botLink.ok ? (
								<p className='landing__unavailable' lang={locale}>
									{copy.botsUnavailable}
								</p>
							) : null}
						</div>
					</div>
				</div>
			</main>
			<aside className='landing__panel landing__panel--warning' role='note'>
				<span className='landing__warn-icon' aria-hidden='true' />
				<p className='landing__notice' lang={locale}>
					{copy.notice}
				</p>
			</aside>
		</div>
	)
}
